/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Data category tweaks",
  "description": "Provides tweaks for the Data (\"Variables\") block category.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "settings": [
    {
      "dynamic": true,
      "name": "Separate List Category",
      "id": "separateListCategory",
      "type": "boolean",
      "default": true
    },
    {
      "dynamic": true,
      "name": "Separate Sprite-only Variables",
      "id": "separateLocalVariables",
      "type": "boolean",
      "default": false
    },
    {
      "dynamic": true,
      "name": "Move data blocks above variables list",
      "id": "moveReportersDown",
      "type": "boolean",
      "default": false
    }
  ],
  "tags": [
    "recommended"
  ],
  "enabledByDefault": false
};
export default manifest;
